import { cn } from "lib/utils";

export interface DeltaInfo { arrow: "▲" | "▼" | "–"; text: string; good: boolean | null }

/** How a number moved against the period before: the size of the move, and whether that is good (null = no judgement). */
export function deltaInfo(cur: number | null, prev: number | null, opts: { unit?: "points" | "hours" | ""; lowerIsBetter?: boolean } = {}): DeltaInfo | null {
  if (cur === null || prev === null) return null;
  const diff = Math.round((cur - prev) * 10) / 10;
  if (diff === 0) return { arrow: "–", text: "no change", good: null };
  const size = opts.unit === "points" ? `${Math.abs(diff)} points` : opts.unit === "hours" ? (Math.abs(diff) < 48 ? `${Math.abs(diff)} h` : `${Math.round(Math.abs(diff) / 24 * 10) / 10} days`) : `${Math.abs(diff)}`;
  const up = diff > 0;
  return { arrow: up ? "▲" : "▼", text: `${up ? "+" : "-"}${size}`, good: opts.lowerIsBetter ? !up : up };
}

/** A small "▲ +8 points vs the previous 30 days" line for a tile hint. Only the arrow wears the good/bad colour; the words stay in text ink. */
export default function Delta({ info, label }: { info: DeltaInfo | null; label: string }) {
  if (!info) return <span className="mt-1 block text-xs text-muted-foreground" data-testid="delta">No data in {label}</span>;
  return (
    <span className="mt-1 block text-xs text-muted-foreground" data-testid="delta">
      <span aria-hidden className={cn("mr-1", info.good === true && "text-success", info.good === false && "text-destructive")}>{info.arrow}</span>
      <span className="text-foreground font-medium">{info.text}</span> vs {label}
    </span>
  );
}
